import { render, staticRenderFns } from "./feed-item.vue?vue&type=template&id=e5c04b82&scoped=true&"
import script from "./feed-item.vue?vue&type=script&lang=js&"
export * from "./feed-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c04b82",
  null
  
)

export default component.exports